import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ONBOARDING_DISMISSED_KEY = 'sasity_onboarding_dismissed';

const highlights = [
  {
    title: 'First: Connect & Add Instruments',
    description: 'Connect your broker, then add instruments in Strategies to start receiving market data. Data flows within 15 minutes.',
  },
  {
    title: 'Dashboard & Charts',
    description: 'Interactive candlestick charts for all your instruments with technical indicator overlays.',
  },
  {
    title: 'Strategy & Modes',
    description: 'Configure trading strategies per instrument and toggle between Autonomous, Signal Only, and Manual modes.',
  },
  {
    title: 'Notifications & Approvals',
    description: 'Multi-channel alerts (Telegram, email, in-app) and trade approval workflow for full control.',
  },
];

export default function OnboardingOverlay() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(ONBOARDING_DISMISSED_KEY);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  const dismiss = (optOut: boolean) => {
    if (optOut) {
      localStorage.setItem(ONBOARDING_DISMISSED_KEY, 'true');
    }
    setVisible(false);
  };

  const launchGuide = () => {
    localStorage.setItem(ONBOARDING_DISMISSED_KEY, 'true');
    setVisible(false);
    navigate('/guide');
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-label="Welcome onboarding"
    >
      <div className="rounded-lg border border-[#222] bg-[#141414] max-w-lg w-full mx-4 p-6">
        <h2 className="text-xl font-bold text-white mb-2">Welcome to TradeFluency</h2>
        <p className="text-gray-400 mb-4">
          Here's a quick look at what the platform offers. You can also take the full Getting Started guide.
        </p>

        <ul className="space-y-3 mb-6">
          {highlights.map((item) => (
            <li key={item.title} className="flex gap-3">
              <span className="text-white mt-0.5">●</span>
              <div>
                <p className="font-medium text-sm text-white">{item.title}</p>
                <p className="text-xs text-gray-500">{item.description}</p>
              </div>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-2">
          <button
            onClick={launchGuide}
            className="w-full px-4 py-2 rounded bg-white text-black font-medium hover:bg-gray-200"
          >
            Launch Getting Started Guide
          </button>
          <button
            onClick={() => dismiss(false)}
            className="w-full px-4 py-2 rounded bg-[#222] text-gray-300 hover:bg-[#1e1e1e] text-sm"
          >
            Dismiss for now
          </button>
          <button
            onClick={() => dismiss(true)}
            className="w-full text-xs text-[#666] hover:text-gray-400"
          >
            Don't show this again
          </button>
        </div>
      </div>
    </div>
  );
}
